import { InputRadioButtonsBarComponent } from './input-radio-buttons-bar.component';

export default angular
  .module('sfMobile.components.input-radio-buttons-bar', [])
  .component('sfInputRadioButtonsBar', InputRadioButtonsBarComponent).name;
